/**
 * Logo Component
 * Professional logo for Ebook Genius
 */

import { BookOpen } from 'lucide-react'
import { Link } from 'react-router-dom'

interface LogoProps {
  size?: 'sm' | 'md' | 'lg'
  showText?: boolean
}

const sizeClasses = {
  sm: {
    icon: 'h-6 w-6',
    text: 'text-lg',
  },
  md: {
    icon: 'h-8 w-8',
    text: 'text-xl',
  },
  lg: {
    icon: 'h-10 w-10',
    text: 'text-2xl',
  },
}

export function Logo({ size = 'md', showText = true }: LogoProps) {
  const { icon, text } = sizeClasses[size]

  return (
    <Link to="/" className="flex items-center gap-2 group">
      <div className="bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg p-1.5 shadow-md group-hover:shadow-lg transition-shadow">
        <BookOpen className={`${icon} text-white`} />
      </div>
      {showText && (
        <div className="flex flex-col">
          <span className={`${text} font-bold text-gray-900 leading-tight`}>
            Ebook Genius
          </span>
          <span className="text-xs text-gray-500 leading-tight">Write & Create</span>
        </div>
      )}
    </Link>
  )
}
